<div class="flex flex-col gap-2">
  <p-button
    *ngIf="activeForm"
    [label]="
      'common.info.forms.complianceForm.button.fillNew.label' | translate
    "
    icon="pi pi-pen-to-square"
    severity="primary"
    (click)="fillNewForm()"
  />
  <div
    *ngFor="let item of complianceFormItems"
    class="flex gap-4 flex-row border border-surface rounded-xl p-2"
  >
    <div class="flex gap-2 flex-row justify-center items-center">
      <p-tag
        class="align-middle text-xs"
        [severity]="$any(item.severity)"
        [value]="
          'common.info.forms.complianceForm.status.' + item.status | translate
        "
      />
    </div>
    <div class="flex items-center flex-1">{{ item.date }}</div>
    <div class="flex gap-2 flex-row">
      <p-button
        *ngIf="item.canView"
        icon="pi pi-eye"
        aria-label="{{
          'common.info.forms.complianceForm.button.preview.label' | translate
        }}"
        (click)="viewForm(item)"
      />
      <p-button
        *ngIf="item.canApprove"
        icon="pi pi pi-check"
        aria-label="{{
          'common.info.forms.complianceForm.button.approve.label' | translate
        }}"
        (click)="approveForm(item)"
      />
    </div>
  </div>
</div>

<p-dialog
  *ngIf="selectedFormModel && showSelectedForm"
  [header]="'common.info.forms.complianceForm.modal.preview.title' | translate"
  [modal]="true"
  [(visible)]="showSelectedForm"
  [appendTo]="'body'"
>
  <form-viewer
    [disableForm]="true"
    [forceDisableForm]="true"
    [(payload)]="selectedFormModel"
    [formConfig]="selectedFormConfig"
  ></form-viewer>
  <div class="flex flex-1">
    <div class="flex flex-1 pt-6 gap-4"></div>
    <div class="flex">
      <div class="flex justify-end pt-6 gap-4">
        <p-button
          [label]="'formsCommon.editor.action.close' | translate"
          severity="primary"
          (click)="closeSelectedDialog()"
        />
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  *ngIf="fillNewFormModel && showFillNewForm"
  [header]="'common.info.forms.complianceForm.modal.fillNew.title' | translate"
  [modal]="true"
  [(visible)]="showFillNewForm"
  [appendTo]="'body'"
>
  <form-viewer
    [formButtons]="fillNewFormButtons"
    [(payload)]="fillNewFormModel"
    [formConfig]="fillNewFormConfig"
    (payloadSubmit)="onSubmitComplianceForm($event)"
  ></form-viewer>
</p-dialog>
<!-- <div
            *ngIf="showMessageNoCompliance"
            class="font-medium leading-normal"
          >
            {{
              "environments.info.forms.complianceForm.message.noFormActive"
                | translate
            }}
          </div> -->

<!--<div class="flex flex-col gap-2">
  <p-message
    class="mb-6"
    *ngIf="showMessageCompliance"
    [severity]="showMessageSeverity"
    >{{
      "common.info.forms.complianceForm.message." + showMessageCompliance
        | translate
    }}</p-message
  >

  <p-message class="mb-6" *ngIf="activeFilledForm" [severity]="'info'"
    >{{ "common.info.forms.complianceForm.message.lastUpdatedOn" | translate }}
    {{ getShortDateFromDateStr(activeFilledForm.updatedAt) }}</p-message
  >

  <p-message
    class="mb-6"
    *ngIf="activeFilledForm?.manuallyApprovedAt"
    [severity]="'info'"
    >{{
      "common.info.forms.complianceForm.message.manuallyApprovedAt" | translate
    }}
    {{
      getShortDateFromDateStr(activeFilledForm?.manuallyApprovedAt || 0)
    }}</p-message
  >

  <ng-container *ngIf="showComplianceForm">

    <form-viewer
      *ngIf="formConfig"
      [(payload)]="formModel"
      [formConfig]="formConfig"
      [formButtons]="activeFilledForm ? [] : formButtons"
      [disableForm]="!!activeFilledForm"
      (payloadChange)="onPayloadChangeComplianceForm($event)"
      (payloadSubmit)="onSubmitComplianceForm($event)"
    ></form-viewer>

    <p-message
      *ngIf="!activeFilledForm?.manuallyApprovedAt"
      [severity]="requiresManualApproval ? 'warn' : 'success'"
      variant="outlined"
    >
      {{
        requiresManualApproval
          ? ("common.info.forms.complianceForm.message.manualApprovalRequired"
            | translate)
          : ("common.info.forms.complianceForm.message.noManualApprovalRequired"
            | translate)
      }}</p-message
    >
    <div class="flex justify-end">
      <p-button
        *ngIf="
          requiresManualApproval &&
          !!activeFilledForm &&
          !activeFilledForm.manuallyApprovedAt
        "
        (click)="onManuallyApproveCompliance()"
        label="Manually approve"
        icon="pi pi-check"
        iconPos="right"
      />
    </div>
  </ng-container>
</div> -->
